import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=787c8202&scoped=true&"
import script from "./ChannelEdit.vue?vue&type=script&lang=js&"
export * from "./ChannelEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChannelEdit.vue?vue&type=style&index=0&id=787c8202&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c8202",
  null
  
)

export default component.exports